
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accessory-card',
  standalone: true,
  template: `
    <div class="accessory-card">
      <strong>{{accessory?.name}}</strong>
      <span>{{accessory?.position}}</span>
    </div>
  `
})
export class AccessoryCardComponent {
  @Input() accessory: any;
}
